import { render, staticRenderFns } from "./ConfirmedCard.vue?vue&type=template&id=83acc340&scoped=true&"
import script from "./ConfirmedCard.vue?vue&type=script&lang=js&"
export * from "./ConfirmedCard.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmedCard.vue?vue&type=style&index=0&id=83acc340&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83acc340",
  null
  
)

export default component.exports